__turbopack_context__.v({
  "hasBackground": "work-slider-module-scss-module__fvFvJa__hasBackground",
  "root": "work-slider-module-scss-module__fvFvJa__root",
  "u-animation-bounce": "work-slider-module-scss-module__fvFvJa__u-animation-bounce",
});
